// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__quQKB","icon":"styles_icon__15g5s","title":"styles_title__1dpww"};